import { AlertCircle, RefreshCw } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Card, CardContent } from '@/components/ui/card';

type TransientLoadNoticeProps = {
  title?: string;
  message?: string;
  onRetry?: () => void;
  isRetrying?: boolean;
};

export function TransientLoadNotice({
  title = 'System is busy',
  message = 'The server is temporarily under load. Please wait a moment or try again.',
  onRetry,
  isRetrying = false,
}: TransientLoadNoticeProps) {
  return (
    <Card>
      <CardContent className="p-8 text-center">
        {isRetrying ? (
          <RefreshCw className="h-12 w-12 mx-auto mb-4 text-amber-500 animate-spin" />
        ) : (
          <AlertCircle className="h-12 w-12 mx-auto mb-4 text-amber-500" />
        )}
        <p className="text-gray-900 font-medium">{title}</p>
        <p className="text-gray-600 mt-2 text-sm max-w-lg mx-auto">{message}</p>
        {onRetry && (
          <Button
            type="button"
            variant="outline"
            className="mt-4"
            disabled={isRetrying}
            onClick={onRetry}
          >
            {isRetrying ? 'Retrying…' : 'Try again'}
          </Button>
        )}
      </CardContent>
    </Card>
  );
}
